import React, { useRef } from 'react';
import { Box } from '@mui/material';
import { usePreviewBoardVisibility } from '../common/usePreviewBoardVisibility';
import { useQueuedPreviewMount } from '../common/previewBoardMountQueue';
import {
  previewBoardTapCaptureContainerSx,
  previewBoardTapCaptureOverlaySx,
} from '../common/previewBoardShell';
import CoursePreviewBoards from './CoursePreviewBoards';
import { COURSE_PREVIEW_BOARD_COUNT } from './coursePreviewBoardSizes';
import { useFittedCoursePreviewBoardWidth } from './useFittedCoursePreviewBoardWidth';
import type { CoursePreviewThumbnail, TrainSide } from './types';

type FittedCoursePreviewBoardsProps = {
  previews?: CoursePreviewThumbnail[];
  trainSide?: TrainSide;
  boardCount?: number;
  align?: 'flex-start' | 'center' | 'flex-end';
  staticPreviews?: boolean;
};

const FittedCoursePreviewBoards = ({
  previews,
  trainSide,
  boardCount = COURSE_PREVIEW_BOARD_COUNT,
  align = 'flex-start',
  staticPreviews = false,
}: FittedCoursePreviewBoardsProps) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const boardWidth = useFittedCoursePreviewBoardWidth(containerRef, boardCount);
  const { inViewport, animationsActive } = usePreviewBoardVisibility(containerRef);
  const mountBoards = useQueuedPreviewMount(inViewport);

  return (
    <Box ref={containerRef} sx={previewBoardTapCaptureContainerSx}>
      <Box sx={{ display: 'flex', justifyContent: align }}>
        <CoursePreviewBoards
          previews={previews}
          trainSide={trainSide}
          boardWidth={boardWidth}
          boardCount={boardCount}
          mountBoards={mountBoards}
          animationsActive={animationsActive}
          staticPreviews={staticPreviews}
        />
      </Box>
      {/* Capture taps on animated boards so parent card links work on mobile. */}
      <Box aria-hidden sx={previewBoardTapCaptureOverlaySx} />
    </Box>
  );
};

export default FittedCoursePreviewBoards;
